export const LogoFull = ({
  color = '#97ded3',
  size,
}: {
  color?: string;
  size?: number;
}) => (
  <span
    style={{
      color,
      fontWeight: 700,
      fontSize: size ?? 21,
      whiteSpace: 'nowrap',
    }}
  >
    Snap <span style={{ fontWeight: 400, fontSize: size ?? 15 }}>eHealth</span>
  </span>
);
